import axios from 'axios';
import context from '../main';
import store from '../store';
import msgModal from '../components/BaseUi/MessageModal/src';
import qs from 'qs';
import router from '@/router';
import { decryptAES } from '@/utils/index';
// import { getQueryString } from '@/utils'

const LoadingInstance = {
  target: null,
  count: 0,
};
const closeLoading = () => {
  if (LoadingInstance.count > 0) {
    LoadingInstance.count = LoadingInstance.count - 1;
  }
  if (LoadingInstance.count === 0 && !context.config.globalProperties.$getTextLoadingStatus()) {
    LoadingInstance.target.hide();
    LoadingInstance.target = null;
  }
};

const transformModalData = response => {
  if (response?.data?.note) {
    return false;
  }
  return true;
};

const checkStatus = response => {
  const status = response.status || -1000; // -1000 自己定义，连接错误的status
  if ((status >= 200 && status < 300) || status === 304) {
    // 如果http状态码正常，则直接返回数据
    return response.data;
  }
  let errorInfo = '';
  switch (status) {
    case -1:
      errorInfo = '远程服务响应失败,请稍后重试';
      break;
    case 400:
      errorInfo = '400：错误请求';
      break;
    case 401:
      errorInfo = '401：访问令牌无效或已过期';
      break;
    case 403:
      errorInfo = '403：拒绝访问';
      break;
    case 404:
      errorInfo = '404：资源不存在';
      break;
    case 405:
      errorInfo = '405：请求方法未允许';
      break;
    case 408:
      errorInfo = '408：请求超时';
      break;
    case 500:
      errorInfo = '500：访问服务失败';
      break;
    case 501:
      errorInfo = '501：未实现';
      break;
    case 502:
      errorInfo = '502：无效网关';
      break;
    case 503:
      errorInfo = '503：服务不可用';
      break;
    default:
      errorInfo = '连接错误';
  }
  return {
    status,
    msg: errorInfo,
  };
};

// eslint-disable-next-line func-style
function createInstance(config) {
  // 1.form表单格式 post请求 的参数
  if (config.headers === undefined && config.method.includes('POST')) {
    config.headers = {};
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.data = qs.stringify({ lang: localStorage.getItem('lang'), ...config.data });
  }
  // 2.form表单格式 get请求 的参数
  if (config.headers === undefined && config.method.includes('GET')) {
    config.headers = {};
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }
  // 3.处理register接口--有传headers其他属性但又是form表单形式的情况
  if (config.headers['Content-Type'] === undefined) {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.data = qs.stringify({ lang: localStorage.getItem('lang'), ...config.data });
  }
  // 4.其他格式不用处理，在接口内处理好
  const instance = axios.create({
    headers: {
      'Content-Type': config.headers?.['Content-Type'] ?? 'application/x-www-form-urlencoded',
      'X-Visa-Region': 'canada',
      unEncryptToken: true,
    },
    data: { lang: localStorage.getItem('lang'), ...config.data },
  });
  instance.interceptors.request.use(
    config => {
      config.headers.Authorization =
        sessionStorage.getItem('token') && decryptAES(sessionStorage.getItem('token'));
      // 多个请求只有一个loading，第一个请求开启loading，最后一个返回数据的请求完成后关闭loading
      if (!context.config.globalProperties.$getTextLoadingStatus()) {
        LoadingInstance.count = LoadingInstance.count + 1;
      }
      if (LoadingInstance.count === 1) {
        LoadingInstance.target = context.config.globalProperties.$loading;
        LoadingInstance.target.show();
      }
      return config;
    },
    error => {
      Promise.error(error);
    },
  );

  instance.interceptors.response.use(
    response => {
      // 判断是否需要重新登录
      // PDF正常返回为text/xml，被顶号时res.type为application/json
      if (
        response?.data?.needLogin ||
        (response?.data?.type !== 'text/xml' && response?.data.constructor === Blob)
      ) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('isLogin');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('vcesStatus');
        sessionStorage.removeItem('userContactToken');
        store.commit('setState', {
          state: 'isLogin',
          values: false,
        });
        store.commit('setState', {
          state: 'userInfo',
          values: null,
        });
        store.commit('setState', {
          state: 'vcesStatus',
          values: null,
        });
        store.commit('setHeaderBankLogo', null);
        // 产品需求，顶号先跳到首页再展示弹窗
        router.push('/');
        !response.config.url.includes('/basic-api/visa/latam/login/logout') &&
          msgModal.show({
            image: false,
            desc: response?.data?.note ?? 'need-login',
            confirmBtn: 'ok',
            justHide: true,
            closeIcon: true,
            i18nNeed: transformModalData(response),
            callback: () => {
              router.push('/login');
            },
          });
      }

      closeLoading();
      // if (response?.data?.state === '0' && response?.data?.errorCode === '20002') {
      //   // token过期
      //   throw new Error('Authorization fail.');
      // }
      return Promise.resolve(checkStatus(response));
    },
    error => {
      console.log('error ', { error });
      closeLoading();
      // 请求、响应超时出现弹窗
      const timeOutError = { error }.error.message;
      if (timeOutError.includes('timeout') || timeOutError.includes('TIME')) {
        msgModal.show({
          i18nNeed: true,
          image: true,
          title: 'connection-issue',
          desc: 'please-try-again',
          confirmBtn: 'try-again',
          justHide: true,
          callback: () => {
            // TODO: 如果页面一次加载多个接口，这里只会重新请求最后一个接口，需要将本次页面的所有请求记录下来
            // 需要重复弹窗axios改为instance，目前只弹窗一次
            return instance.request(error.config);
          },
        });
      }
      const { response } = error;
      if (response) {
        //   const {
        //     data: { status },
        //   } = response;
        // 后端报5xx错误
        if (String(response.status).startsWith('5')) {
          msgModal.show({
            i18nNeed: true,
            image: true,
            sucImgSrc: require('../assets/images/connectError.png'),
            title: 'connection-issue',
            desc: 'please-try-again',
            confirmBtn: 'try-again',
            justHide: true,
            callback: () => {
              const that = msgModal;
              // 需要重复弹窗axios改为instance，目前只弹窗一次
              return that.getIssueApi(error.config);
            },
          });
        }
      } else {
        return Promise.reject(error);
      }
    },
  );
  return instance(config);
}

export default createInstance;
